import {useState, useEffect, useRef} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {toast} from 'react-toastify'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import './style.css'
import {useNavigate, useParams} from 'react-router-dom'

import AlertModal from './AlertModal'
import Member from './Member'
import ProfilePana from './ProfilePana'
import Note from './Note'
import History from './History'
import TypeProposal from './TypeProposal'
import IndicatorAssessmentVerificator from './IndicatorAssessmentVerificator'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import BackButton from '../Monitoring/BackButton'
import {clearLocalStorageExcept} from 'thesis-and-dissertations/helpers/helper'
import ProposalSummary from './ProposalSummary'

const api = new Api()

const DetailPage = () => {
  let navigate = useNavigate()
  const {proposalId, interviewId} = useParams()

  const [fieldRefs, setFieldRefs] = useState<any>({
    nilai: useRef(null),
    aspek: useRef(null),
  })

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<any>([])

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false)
  const [formValue, setFormValue] = useState<any>({})
  const [assessmentType, setAssessmentType] = useState('')
  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (proposalId) {
      fetchDetailProposal(proposalId)
      setAssessmentType('proposal')
      return
    }

    if (interviewId) {
      setAssessmentType('substansi')
      fetchDetailInterview(interviewId)
      return
    }
  }, [])

  useEffect(() => {
    if (!errors) {
      return
    }

    scrollToElement(errors)
  }, [errors])

  const scrollToElement = (errors: any) => {
    const firstErrorField = Object.keys(errors)[0]
    const target = fieldRefs[firstErrorField]

    if (target && target.current) {
      const yOffset = -80 // jika ada header
      const y = target.current.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({top: y, behavior: 'smooth'})
    }
  }

  const handleCloseAlertModal = (action: boolean, isOk: boolean) => {
    setShowAlertModal(action)

    if (isOk) {
      saveAssessment()
    }
  }

  const fetchDetailInterview = (id: any) => {
    setLoading(true)
    api
      .getDetailInterview(id)
      .then((response: any) => {
        const {data} = response.data
        setData(data)

        setFormValue({...formValue, assignment_id: id, catatan: data?.data[0]?.catatan})
        setLoading(false)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response
        setErrors(data?.meta?.error)
        toast.error(data?.message ?? data?.meta?.message)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
      })
  }

  const fetchDetailProposal = (id: any) => {
    setLoading(true)
    api
      .getDetailProposal(id)
      .then((response: any) => {
        const {data} = response.data
        setData(data)

        setFormValue({...formValue, assignment_id: id, catatan: data?.data[0]?.catatan})
        setLoading(false)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response
        setErrors(data?.meta?.error)

        toast.error(data?.message ?? data?.meta?.message)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
      })
  }

  const handleInput = (name: any, value: any) => {
    setFormValue({...formValue, [name]: value})
    setErrors({})
  }

  const saveProposal = () => {
    setLoading(true)
    api
      .saveAssessmentProposal(formValue)
      .then((response: any) => {
        const {data} = response.data
        setLoading(false)
        navigate('/dashboard')
        toast.success(data?.message ?? data?.meta?.message ?? 'Berhasil simpan data')
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response
        setErrors(data?.meta?.error ?? data?.errors)
        toast.error(data?.message ?? data?.meta?.message)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
      })
  }

  const saveInterview = () => {
    setLoading(true)
    api
      .saveAssessmentInterview(formValue)
      .then((response: any) => {
        const {data} = response.data
        setLoading(false)
        navigate('/dashboard')
        toast.success(data?.message ?? data?.meta?.message ?? 'Berhasil simpan data')
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response

        toast.error(data?.message ?? data?.meta?.message)
        setErrors(data?.meta?.error ?? data?.errors)

        toast.error(data?.message ?? data?.meta?.message)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
      })
  }

  const saveAssessment = () => {
    if (proposalId) {
      saveProposal()
      return
    }

    if (interviewId) {
      saveInterview()
    }
  }

  return (
    <>
      <AlertModal showModal={showAlertModal} handleShowModalAlert={handleCloseAlertModal} />

      <div className='row'>
        <div className='col-md-12'>
          <BackButton to='/dashboard' />
        </div>

        <div className='col-md-12 px-6 mt-8'>
          <ProfilePana data={data?.pendaftaran} />
        </div>

        <div className='col-md-12 mt-8'>
          <Member data={data?.pendaftaran} allowEdit={false} reloadData={{}} />
        </div>

        <div className='col-md-12 mt-8'>
          <div className='card'>
            <div className='px-8 py-7'>
              <div className='d-flex align-items-center gap-3'>
                <p className='fs-4 fw-bold'>Tema Essay Utama</p>
              </div>
            </div>
            <div className='px-8 pb-8'>
              <div className='p-5 border rounded-top' style={{backgroundColor: '#F4F7FE'}}>
                <p className='mb-0'>Tema Essay</p>
              </div>
              <div className='p-5 border'>
                <p className='mb-0'>{data?.pendaftaran?.judul_proposal || '-'}</p>
              </div>
            </div>
          </div>
        </div>

        <div className='col-md-12 mt-8'>
          <ProposalSummary
            title='Ringkasan Proposal Utama'
            value={data?.pendaftaran?.ringkasan_proposal}
          />
        </div>

        {data?.pendaftaran?.anggota?.length > 0 && (
          <>
            <div className='col-md-12 mt-8'>
              <div className='card'>
                <div className='px-8 py-7'>
                  <div className='d-flex align-items-center gap-3'>
                    <p className='fs-4 fw-bold'>Tema Essay Kedua</p>
                  </div>
                </div>
                <div className='px-8 pb-8'>
                  <div className='p-5 border rounded-top' style={{backgroundColor: '#F4F7FE'}}>
                    <p className='mb-0'>Tema Essay</p>
                  </div>
                  <div className='p-5 border'>
                    <p className='mb-0'>{data?.pendaftaran?.judul_proposal_2 || '-'}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-12 mt-8'>
              <ProposalSummary
                title='Ringkasan Proposal Kedua'
                value={data?.pendaftaran?.ringkasan_proposal_2}
              />
            </div>
          </>
        )}

        <div className='col-md-12 mt-8'>
          <TypeProposal
            radioButton={false}
            title='Jenis Dokumen Proposal'
            data={data?.pendaftaran}
            handleInput={handleInput}
            dataFile={data}
            isAdmin={false}
            errors={errors}
            fieldRefs={fieldRefs}
          />
        </div>

        <div className='col-md-12 mt-8'>
          <IndicatorAssessmentVerificator
            dataProps={{}}
            showInfo={true}
            handleInput={handleInput}
            fieldRefs={fieldRefs}
            assessmentType={assessmentType}
            errors={errors}
            defaultValue={data?.data?.length > 0 ? data?.data[0] : null}
          />
        </div>

        <div className='col-md-12 mt-8'>
          <Note
            name='catatan'
            title='Catatan Penilaian'
            handleInput={handleInput}
            defaultValue={formValue?.catatan}
            readOnly={false}
            defaultDataNote={[]}
            errors={errors}
          />
        </div>

        {/* <div className='col-md-12 mt-8'>
          <History />
        </div> */}

        <div className='col-md-12 mt-8'>
          <div className='card'>
            <div className='px-7'>
              <hr className='dashed-line mt-6' />

              <button
                className='btn btn-primary btn-sm w-100 mt-3'
                style={{background: 'var(--Primary-L-500, #F95E2F)'}}
                disabled={loading}
                onClick={() => setShowAlertModal(true)}
              >
                {loading ? 'Loading...' : 'Simpan'}
              </button>

              <button
                className='btn btn-sm w-100 mt-3 mb-3 text-primary'
                onClick={() => navigate('/dashboard')}
                disabled={loading}
              >
                Batal
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const Detail = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'PANA',
            path: '/',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '/',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Jenis Penilaian
      </PageTitle>
      <DetailPage />
    </>
  )
}

export default Detail
